export const DisclaimerStringMap = {
  DisclaimerLabelText: _TL_('Disclaimer'),
  Disclaimers_Campiagn_Description: _TL_('Show a disclaimer in ads for this campaign'),
  Disclaimers_Native_Campaign_Description: _TL_('Show a disclaimer in Native ads for this campaign'),
  Disclaimers_Campaign_Hint: _TL_('This is your only opportunity to add a disclaimer to ads in this campaign. If you subsequently remove the disclaimer, the ads in this campaign will not serve.'),
  Disclaimers_Campaign_Hint_New: _TL_('You can enable disclaimers in ads for new or existing campaigns.  Adding a disclaimer means this campaign must always contain one; therefore, if you ever remove the disclaimer, the ads in this campaign will not serve. <br> Once you enable a disclaimer, you’ll lose traffic from publishers who don’t support disclaimers.  '),
  Disclaimers_Add: _TL_('+ Add disclaimer'),
  Disclaimers_Create: _TL_('Create disclaimer'),
  Disclaimers_DisplayLayout_Label: _TL_('Disclaimer layout'),
  Disclaimers_DisplayLayout_Popup: _TL_('Popup layout'),
  Disclaimers_DisplayLayout_AdditionalLine: _TL_('Additional line layout'),
  Disclaimers_DisplayLayout_AdditionalLine_Hint: _TL_('Ads with the additional line layout disclaimer will not have Ad text 2.'),
  Disclaimers_Edit: _TL_('Edit disclaimer'),
  Disclaimers_Name_Label: _TL_('Disclaimer name'),
  Disclaimers_Select: _TL_('Select a disclaimer'),
  Disclaimers_Title_Label: _TL_('Disclaimer title'),
  Disclaimers_Title_Default: _TL_('Disclaimer info'),
  Disclaimers_Dropdown_Disclaimer: _TL_('Disclaimer'),
  Disclaimers_Dropdown_Disclosure: _TL_('Disclosure'),
  Disclaimers_Dropdown_MoreDisclaimer: _TL_('More disclaimer info'),
  Disclaimers_Dropdown_Offer: _TL_('Offer Details'),
  Disclaimers_Dropdown_SafetyInfor: _TL_('Safety Info'),
  Disclaimers_Dropdown_SafetyInformation: _TL_('Safety Information'),
  Disclaimers_Information_Label: _TL_('Disclaimer information'),
  Disclaimers_Edit_Confirmation: _TL_('This disclaimer is associated to other campaigns and any changes to this disclaimer will apply to all associated campaigns.'),
  Disclaimers_Remove_Confirmation: _TL_('Are you sure you want to delete this disclaimer?'),
  Disclaimers_Remove_Confirmation_body: _TL_('Deleting this disclaimer will delete it for all campaigns associated to it. It will stop all ads under the associated campaigns from serving.'),
  Button_Close: _TL_('Button_Close'),
  Cancel: _TL_('Cancel'),
  Save: _TL_('Save'),
  Edit: _TL_('Edit'),
  Remove: _TL_('Remove'),
  LearnMoreLinkText: _TL_('Learn more'),
  'Click to learn more about {{item}}': _TL_('Click to learn more about {{item}}'),
  RemainingCharactersText_New: _TL_('{{count}} characters remaining'),
  ExceededCharactersText_New: _TL_('Exceeded by {{count}} characters'),
  Ad_FinalUrl: _TL_('Final URL'),
  MobileFinalUrl_Label: _TL_('Mobile URL'),
  Loading: _TL_('Loading'),
  Search_No_Result: _TL_('No results found based on your search.'),
  'Found {{totalCount}} Results for {{searchText}}': _TL_('Found {{totalCount}} Results for {{searchText}}'),
  'No results found from {{searchText}}': _TL_('No results found from {{searchText}}'),
  DisclaimerNameRequired: _TL_('Disclaimer name is required'),
  DisclaimerInformationRequired: _TL_('Disclaimer information is required'),
  FinalURLRequired: _TL_('Final URL is required'),
  Validation_Base_Field_Not_Valid: _TL_('Field is not valid'),
  Validation_NotEmpty_Required_Field: _TL_('Required field'),
  Validation_String_Max_Length: _TL_('Field should not exceed {{maxlength}} characters'),
  Validation_String_Invalid_Characters: _TL_('Field contains invalid characters'),
  Validation_Number_Require_Numeric: _TL_('Field requires numeric value'),
  Validation_Number_Max_Length: _TL_('Number should not exceed max length'),
  Validation_Number_Range_Min: _TL_('Number should be larger than {{min}}'),
  Validation_Number_Range_Max: _TL_('Number should be smaller than {{max}}'),
  Validation_Number_Range_Between: _TL_('Number should be between {{min}} and {{max}}'),
  Validation_Array_Size_Max: _TL_('List should have at most {{max}} items'),
  Validation_Array_Size_Between: _TL_('List should have at least {{min}} and at most {{max}} items'),
  Validation_Array_Items_Invalid: _TL_('Some of items in list are invalid'),
  Validation_Array_Items_Duplicate: _TL_('List has duplicate items'),
  Close: _TL_('Close'),
  'Disclaimer editor side panel opened': _TL_('Disclaimer editor side panel opened'),
  EntitySelector_Search_Placeholder: _TL_('Search'),
  'No results found for {{searchText}}': _TL_('No results found for {{searchText}}'),
  '{{itemName}} Selected': _TL_('{{itemName}} Selected'),
  Disclaimers_Should_Check_With_Selected_Disclaimer: _TL_('You should check show disclaimer with a selected disclaimer'),
  EntitySelector_Pagination_Page: _TL_('Page:'),
  EntitySelector_Pagination_TotalPageCountText: _TL_('of'),
  EntitySelector_Pagination_PreviousPageText: _TL_('Previous page'),
  EntitySelector_Pagination_NextPageText: _TL_('Next page'),
};

